import React from 'react';
import { observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import './styles';
import NewAttachment from './_NewAttachment';

// Map that contains the new attachments generated urls.
// It is used inside the blobUrl function to avoid url re-generation
const urls = new WeakMap();

const blobUrl = blob => {
  if (urls.has(blob)) {
    return urls.get(blob);
  } else {
    let url = URL.createObjectURL(blob);
    urls.set(blob, url);
    return url;
  }
};

@injectIntl
@observer
export default class NewAttachmentsContainer extends React.Component {
  render() {
    const { attachable, intl, handleClick } = this.props;

    return (
      <div className={'new-attachments-container'}>
        {attachable.attachmentFilesQueue.map((file, idx) => (
          <NewAttachment
            key={idx}
            file={file}
            handleRemove={() => attachable.removeFileFromQueue(file)}
            blobUrl={blobUrl}
          />
        ))}
        {attachable.attachmentFilesQueue.length > 0 ? (
          <div className="attachment-preview img-thumbnail">
            <div onClick={handleClick}>
              <div className="element-container">
                <i className="file-icon fa fa-plus" />
              </div>
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
